export const host = process.env.REACT_APP_SERVER_HOST;
export const envMode = process.env.NODE_ENV;
export const USE_MOCK_INFERENCE_RESULT =
  process.env.REACT_APP_USE_MOCK_INFERENCE_RESULT === 'true';
